export const mutationTypes = {
  GET_WORKSPACES_SUCCESS: 'GET_WORKSPACES_SUCCESS',
  GET_WORKSPACES_PENDING: 'GET_WORKSPACES_PENDING',
  GET_WORKSPACES_FAILURE: 'GET_WORKSPACES_FAILURE',
  GET_NEW_WORKSPACE_ID_SUCCESS: 'GET_NEW_WORKSPACE_ID_SUCCESS',
  GET_NEW_WORKSPACE_ID_PENDING: 'GET_NEW_WORKSPACE_ID_PENDING',
  GET_NEW_WORKSPACE_ID_FAILURE: 'GET_NEW_WORKSPACE_ID_FAILURE',
  RESET_STATE: 'RESET_STATE'
}

export default {
  mutationTypes
}
